app.component('headerContents', {
    templateUrl: 'app/header/header.html',
    controller: function ($location, $window, $route, $mdSidenav, $interval, localStorageAccess) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            if("lang" in $location.search()) {
                $ctrl.lang = $location.search()["lang"];
            }
            $ctrl.userPolicy = "0";
            var timer;
            timer = $interval(function(){
                var appData = localStorageAccess.getData( "app" );
                $ctrl.userPolicy = appData.userPolicy;
                if($ctrl.userPolicy=="1") {
                    $interval.cancel(timer);
                }
            }, 300);
        };
        $ctrl.langChange = function(lang) {
            if(lang=="en") {
                 $window.location.href = "index.php";
            }
            else {
                 $window.location.href = "index.php?lang=en";
            }
        };
        $ctrl.sidenav_info = {
            "header" : {
                "username" : "LIRフリー版ユーザー",
                "avator" : "app/common/image/lir-avtor.png",
            },
            "contents" : {
                "top" : [{
                    "icon" : "app/common/image/ic_home_black_24dp_2x.png",
                    "title" : "ホーム",
                    "path" : "/home",
                    "alt" : "home"
                }],
                "middle" : [{
                    "icon" : "app/common/image/6_01_1.png",
                    "title" : "食事チェック",
                    "path" : "/eatlife_check_top",
                    "alt" : "eatlife_check"
                },
                {
                    "icon" : "app/common/image/6_02_1.png",
                    "title" : "食事バランス",
                    "path" : "/foodbalance_basiccheck",
                    "alt" : "foodbalance"
                },
                {
                    "icon" : "app/common/image/2_07_1.png",
                    "title" : "健診結果",
                    "path" : "/medical",
                    "alt" : "medical"
                },
                {
                    "icon" : "app/common/image/6_04_1.png",
                    "title" : "すこやかレシピ",
                    "path" : "/recipe",
                    "alt" : "recipe"
                }],
                "bottom" : [{
                    "icon" : "app/common/image/ic_link_black_24dp_2x.png",
                    "title" : "食の臨床試験",
                    "path" : "https://healthy.do-johodai.ac.jp"
                },
                {
                    "icon" : "app/common/image/ic_link_black_24dp_2x.png",
                    "title" : "ヘルシーＤｏ",
                    "path" : "http://www.pref.hokkaido.lg.jp/kz/sss/ks/hyouziseido.htm"
                }]
            },
        };
        $ctrl.toggleLeftMenu = function() {
            $mdSidenav('left').toggle();
        };
        $ctrl.changeLocation = function(path) {
            $location.path(path);
            $mdSidenav('left').toggle();
        };
        $ctrl.openPage = function(url) {
            $window.open(url);
            $mdSidenav('left').toggle();
        }
        $ctrl.gohome = function() {
            $location.path('/home');
        };
        $ctrl.goUserPolicy = function() {
            $location.path("/user_policy");
        }
    }
});
